import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useNavigate } from "react-router";
import * as Sentry from "@sentry/react";
import axios from "axios";
import "../styles/globalErrorHandler.style.css";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const isProduction = process.env?.REACT_APP_ENVIORNMENT_KEY === "production";
  return (
    <div role="alert" className="global-error-wrap">
      <div>
        <code>{isProduction ? "Something went wrong!" : error.message}</code>
      </div>
      <span onClick={resetErrorBoundary}>Go to Home page</span>
    </div>
  );
};

export const GlobalErrorHandler = ({ children }) => {
  const navigate = useNavigate();

  const handleError = (error, info) => {
    const isAxiosError = axios.isAxiosError(error);
    const isNetworkError = !error?.response;
    const isCanceled = error?.code === "ERR_CANCELED";

    if (!isAxiosError || (!isNetworkError && !isCanceled)) {
      Sentry.captureException(error);
    }
  };

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => navigate("/", { replace: true })}
      onError={handleError}
    >
      {children}
    </ErrorBoundary>
  );
};
